import * as ChapterType from "utils/ChapterType";
import getActiveSlideIndex from "selectors/chapter/slideshow/getActiveSlideIndex";
import getAdPlaying from "selectors/ads/getAdPlaying";
import getFlattenedQuestionList from "selectors/chapter/qa/getFlattenedQuestionList";
import pluralize from "pluralize";
import { createSelector } from "reselect";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import padStart from "lodash/padStart";
import getCurrentQuestionIndex from "selectors/chapter/getCurrentQuestionIndex";

export default createSelector(
  getActiveSlideIndex,
  getAdPlaying,
  getChapterEntity,
  getCurrentQuestionIndex,
  getFlattenedQuestionList,
  (
    activeSlideIndex,
    adPlaying,
    chapterEntity,
    currentQuestionIndex,
    flattenedQuestionList,
  ) => {
    if (adPlaying) {
      return "Advertisement";
    }
    let value = "";
    let type = chapterEntity.type;

    if (chapterEntity.type === ChapterType.INTERVIEW) {
      value =
        currentQuestionIndex < 0
          ? `${flattenedQuestionList.length} ${pluralize(
              "Option",
              flattenedQuestionList.length,
            )}`
          : `${currentQuestionIndex + 1} / ${flattenedQuestionList.length}`;
      type = "Explainer";
    } else if (
      chapterEntity.type === ChapterType.SLIDESHOW &&
      chapterEntity.slides
    ) {
      value = `${activeSlideIndex + 1} / ${
        chapterEntity.slides && chapterEntity.slides.length
      }`;
    } else if (chapterEntity.type === ChapterType.PATHFINDER) {
      if (chapterEntity.cuepoints) {
        value = `${chapterEntity.cuepoints.length} ${pluralize(
          "Choice",
          chapterEntity.cuepoints.length,
        )}`;
      } else {
        value = "0 Choices";
      }
    } else {
      value = `${Math.floor(chapterEntity.duration / 1000 / 60)}:${padStart(
        Math.floor((chapterEntity.duration / 1000) % 60).toString(),
        2,
        "0",
      )}`;
    }

    return `${type}: ${value}`;
  },
);
